import React from "react";

const DisplayLoginContext = React.createContext({
    displayLogin:'',
    setDisplayLogin:()=>{},
})

export default DisplayLoginContext